import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-ui-modal',
  templateUrl: './new-ui-modal.component.html',
  styleUrls: ['./new-ui-modal.component.scss']
})
export class NewUiModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
